$(function() {

    $('.js-hire-form, .js-hire-close').on('click', function(){
        $('.js-hire-form-receiver').toggleClass('d-none animate__fadeOut animate__fadeIn');
        $('.js-hire-form-wrapper').toggleClass('d-none animate__slideOutDown animate__slideInUp');
    })


});